
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2012_4364)"}},[_c('path',{attrs:{"d":"M37.148 30.283H63.95a31.816 31.816 0 00-7.708-19.093L37.148 30.283z","fill":"#1E1E1E"}}),_c('path',{attrs:{"d":"M34.133 27.268L53.255 8.147A31.872 31.872 0 0034.133.139v27.13z","fill":"#74DBB5"}}),_c('path',{attrs:{"d":"M37.148 34.55l18.767 18.766a31.871 31.871 0 007.978-18.766H37.148zM34.133 63.983a31.844 31.844 0 0018.738-7.68L34.133 37.565v26.418z","fill":"#1E1E1E"}}),_c('path',{attrs:{"d":"M29.867 27.268V.14a31.872 31.872 0 00-19.122 8.008l19.122 19.121z","fill":"#74DBB5"}}),_c('path',{attrs:{"d":"M26.852 30.283L7.758 11.19A31.815 31.815 0 00.05 30.283h26.802zM29.867 37.565L11.129 56.303a31.844 31.844 0 0018.738 7.68V37.565zM26.852 34.55H.107a31.872 31.872 0 007.978 18.766L26.852 34.55z","fill":"#1E1E1E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2012_4364"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .061)","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    